define('common/views/notice_view',['require','exports','module','i18n','base/itemview','ldsh!../templates/notice'],function(require, exports, module) {
  "use strict";

  require("i18n");

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({

    template: require("ldsh!../templates/notice"),

    initialize: function () {
      window.vista = this;
      this._setData();
    },

    helpers: function () {
      return this.data;
    },

    showNotice: function (text, seconds) {
      this._setData(text, true);
      this.render();
      clearTimeout(this._timeoutId);
      this._timeoutId = setTimeout(this.hideNotice.bind(this), seconds * 1000 || 3000);
    },

    hideNotice: function () {
      this._setData();
      this.render();
    },

    _setData: function (text, isVisible) {
      this.data = {
        text: text || '',
        isVisible: !!isVisible
      };
    },

  });

});

